import React from 'react';
import Slider from 'react-slick';

import Config from '@skin_config';

import { BannerItem } from './banner-item';

import './style.scss';

const Banner = () => {
  if (Config.main.homeBannerSlides.length === 1) return <BannerItem {...Config.main.homeBannerSlides[0]} />;

  const sliderContent = Config.main.homeBannerSlides.map((slide, index) => (
    <BannerItem
      {...slide}
      key={index}
      index={index + 1}
    />
  ));

  return (
    <div className="home-banner-slides">
      <Slider
        dots={false}
        accessibility={false}
        arrows={false}
        autoplay
        infinite={sliderContent.length > 1}
        draggable={Config.main.homeBannerSlides.length > 1}
        autoplaySpeed={5000}
        dragging={false}
        slidesToShow={1}
        slidesToScroll={1}
      >
        {sliderContent}
      </Slider>
    </div>
  );
};

export default Banner;
